import { DeletedModelT, ModelFieldsT } from "./common"
import { CompleteMutationRequestType, CompleteQueryRequestType } from "./typedQueries"

export enum AuthPathsE {
  LOGIN = 'login',
  CONFIRM = 'confirm',
  LOGOUT = 'logout',
  ACTIVATE = 'activate'
}

export enum RoleE {
  ADMIN = 'admin',
  MANAGER = 'manager',
}

export type AuthTokensT = {
  accessToken: string,
  refreshToken: string
}

export type LoginT = CompleteMutationRequestType<{
  request: {
    email: string,
    password: string,
  },
  response: {
    accessToken: string,
    refreshToken: string
  }
}>

export type SignupT = CompleteMutationRequestType<{
  request: {
    name: string,
    surname: string
    email: string,
    password: string,
  },
  response: {
    accessToken: string,
    refreshToken: string
  }
}>

export type ConfirmT = CompleteMutationRequestType<{
  request: {
    sessionId: string,
    otpCode: string
  },
  response: AuthTokensT
}>

export type ResentOtpCodeT = CompleteMutationRequestType<{
  request: {
    sessionId: string,
  },
  response: LoginT['response']
}>

export type ActivateT = CompleteMutationRequestType<{
  request: {
    password: string,
  },
  response: AuthTokensT,
  // TODO fix it
  params?: undefined,
  pathParams: {
    activationToken: string,
  }
}>

export type ResetPasswordT = CompleteMutationRequestType<{
  request: ActivateT['request'],
  // TODO fix it
  params?: undefined,
  pathParams: {
    resetPasswordToken: string,
  }
}>

export type ForgotPasswordT = CompleteMutationRequestType<{
  request: {
    identifier: string,
  },
}>

export type SelfT = CompleteQueryRequestType<{
  response: DeletedModelT & ModelFieldsT & {
    email: string,
    name: string,
    role: RoleE,
    surname: string | null,
  }
}>